import React, {useEffect, useState} from "react";
import {
  submissionListColorState,
  parseAmount,
  CURRENCY_EURO,
  isDefined,
  insuranceServiceEnabled,
  insuranceRequested,
  scrollHtmlElementIntoView,
  removeHtmlElementClass,
  addHtmlElementClass,
  renderHomePickupServiceDetails,
  renderReturnShipmentServiceDetails,
  titleize
} from "../../utils/utils";
import I18n from 'i18n.js.erb'
import {parseSubmissionListState} from "../../utils/utils";
import {ItemPricing} from "./SubmissionListContent";
import IconTooltip from "./IconTooltip";
import {
  DiscountSummary,
  InsuranceServiceSummary,
  ShippingServiceSummary,
  UserEmailSummary,
  UserGeneralitiesSummary
} from "./ShowPageSubmissionList";
import OverallEvaluation from "../../backoffice/components/OverallEvaluation";
import PDFGenerator from "./PDFGenerator";



const SubmissionListMinimalCompactDetails = ({
 submissionList
}) => {

  return <React.Fragment>
    {
      submissionList.confirmed_at &&
        <div
          className="bg-aiG-gray2-imp br-50px mx-1 px-2 py-1 my-1 d-flex justify-content-center text-center align-items-center">
          <img src={window.location.origin + '/images/icons/small/calendar.svg'}
               alt="" width="15" height="15" className="mr-2"/>
          {submissionList.confirmed_at}
        </div>
    }

    <div
      className="bg-aiG-gray2-imp br-50px mx-1 px-2 py-1 my-1 d-flex justify-content-center text-center align-items-center">
      <img src={window.location.origin + '/images/icons/small/balls.svg'}
           alt="" width="15" height="15" className="mr-2"/>
      {submissionList.items_count}
    </div>

    <div className="bg-aiG-gray2-imp br-50px mx-1 px-2 py-1 my-1 d-flex justify-content-center text-center align-items-center">
      <img src={window.location.origin + '/images/icons/small/money.svg'}
           alt="" width="15" height="15" className="mr-2"/>
      {parseAmount(submissionList.is_middleman ? submissionList.amount : submissionList.customer_amount, 2)}{CURRENCY_EURO}
    </div>
  </React.Fragment>
}


const SubmissionListStateBadge = ({
  submissionList,
  viewMode
}) => {
  return <div className={`col-5 col-md-${viewMode !== 'grid' ? '2' : '5'} col-xl-${viewMode !== 'grid' ? '1' : '5'} col-xxxl-${viewMode !== 'grid' ? '1' : '5'} px-0 color-white d-flex justify-content-center align-items-center text-center minH-40px-imp z-index-10 text-truncate
                                          cursor-pointer br-top-right-8px br-bottom-left-8px br-bottom-right-0px
                                          br-bottom-left-md-${viewMode !== 'grid' ? '0' : '8'}px br-bottom-right-md-${viewMode !== 'grid' ? '8' : '0'}px`}
              onClick={() => window.location = `/submission_lists/${submissionList.id}`}
              style={{ backgroundColor: submissionListColorState(submissionList.front_office_state) }}>
    <b className="submission-list-state-small-label text-truncate">
      {titleize(parseSubmissionListState(submissionList.front_office_state))}
    </b>
  </div>
}


const SubmissionListIconDetail = ({
  submissionList,
  iconPath,
  label,
  viewMode
}) => {

  return <div className={`d-flex d-md-${viewMode !== 'grid' && isDefined(submissionList.title) && submissionList.title.length > 40 ? 'none' : 'flex'} d-xl-flex bg-aiG-gray2-imp br-50px mx-1 px-2 py-${label ? '1' : '2'} my-1 d-flex justify-content-center text-center align-items-center`}>
    <img src={iconPath} alt="" width="15" height="15"/>
    { label && label }
  </div>
}


const SubmissionListAdditionalServicesCompactDetails = ({
  submissionList,
  viewMode,
  setShowErrorModal,
  isMiddleman
}) => {

  return <React.Fragment>
    {
      submissionList.voucher &&
        <IconTooltip
          tooltipContent={(submissionList.voucher.amount > 0 ? I18n.t('js.indexSubmissionListsPage.requestedServices.discount1') + ' ' + submissionList.voucher.amount + CURRENCY_EURO : I18n.t('js.indexSubmissionListsPage.requestedServices.discount2') + ' ' + (submissionList.voucher.percentage || 0) + '%') + ' ' + I18n.t('js.indexSubmissionListsPage.requestedServices.discount3')}
          customComponentToRender={
            <SubmissionListIconDetail
              submissionList={submissionList}
              iconPath={"/images/icons/small/discount.svg"}
              viewMode={viewMode}
            />
          }
        />
    }

    {
      insuranceRequested(submissionList) &&
        <IconTooltip
          tooltipContent={I18n.t('js.indexSubmissionListsPage.requestedServices.insurance')}
          customComponentToRender={
            <SubmissionListIconDetail
              submissionList={submissionList}
              iconPath={"/images/icons/small/shield.svg"}
              viewMode={viewMode}
            />
          }
        />
    }

    {
      !submissionList.hide_shipment_and_invoicing_info_to_user && submissionList.home_pick_up_requested &&
        <IconTooltip
          tooltipContent={I18n.t('js.indexSubmissionListsPage.requestedServices.homePickUp')}
          customComponentToRender={
            <SubmissionListIconDetail
              submissionList={submissionList}
              iconPath={"/images/icons/small/home-pick-up.svg"}
              viewMode={viewMode}
            />
          }
        />
    }

    {
      !submissionList.hide_shipment_and_invoicing_info_to_user && submissionList.return_delivery_requested &&
        <IconTooltip
          tooltipContent={I18n.t('js.indexSubmissionListsPage.requestedServices.returnShipment')}
          customComponentToRender={
            <SubmissionListIconDetail
              submissionList={submissionList}
              iconPath={"/images/icons/small/shipment.svg"}
              viewMode={viewMode}
            />
          }
        />
    }

    {
      isMiddleman && submissionList.middleman_note &&
        <IconTooltip
          tooltipContent={submissionList.middleman_note}
          customComponentToRender={
            <SubmissionListIconDetail
              submissionList={submissionList}
              iconPath={"/images/icons/small/comment.svg"}
              viewMode={viewMode}
            />
          }
        />
    }

    {
      submissionList.state !== 'draft' &&
        <PDFGenerator
          pdfUrl={`/submission_lists/${submissionList.id}.pdf?pricing_for=${isMiddleman ? 'middleman' : 'customer'}`}
          setShowErrorModal={setShowErrorModal}
          spinnerCssClassList={'d-none'}
          customComponentToRenderCssClass={'d-block d-md-none d-lg-block'}
          customComponentToRender={
            <IconTooltip
              tooltipContent={I18n.t('js.editSubmissionListPage.downloadSummary')}
              customComponentToRender={
                <SubmissionListIconDetail
                  submissionList={submissionList}
                  iconPath={"/images/icons/blue/download-solid.svg"}
                  viewMode={viewMode}
                />
              }
            />
          }
        />
    }


    {
      /* service_type null = scope misto, nessuna pillola */
      isDefined(submissionList.service_type) &&
        <SubmissionListIconDetail
          submissionList={submissionList}
          iconPath={"/images/icons/blue/star.svg"}
          label={
            <React.Fragment>
              <span className="d-flex d-md-none d-lg-flex ml-2">{I18n.t(`js.editSubmissionListPage.webComponent.draft.serviceType.${submissionList.service_type}.title`)}</span>
              <span className="d-none d-md-flex d-lg-none ml-2">{I18n.t(`js.editSubmissionListPage.webComponent.draft.serviceType.${submissionList.service_type}.titleCompact`)}</span>
            </React.Fragment>
          }
          viewMode={viewMode}
        />
    }
  </React.Fragment>
}


const SubmissionListSummaryAllCompactDetails = ({
  submissionList,
  viewMode,
  isSuperMiddleman,
  setShowErrorModal,
  isMiddleman
}) => {


  return <React.Fragment>
    <div className={`py-2 py-md-${viewMode !== 'grid' ? '0' : '2'} px-1 px-md-${viewMode !== 'grid' ? '0' : '1'} ${viewMode !== 'grid' ? 'text-md-truncate' : ''} flex-1 text--white-space-break`}>
      {
        isDefined(submissionList.title) ?
          <span className="text-weight-500 font-size-xxxl-16px">
            {submissionList.title}
          </span>
        :
          <span>&nbsp;</span>
      }
    </div>

    <div className={`d-flex d-md-${viewMode !== 'grid' ? 'none' : 'flex'} justify-content-start justify-content-md-${viewMode !== 'grid' ? 'end' : 'start'} flex-wrap py-0 py-md-${viewMode !== 'grid' ? '0' : '1'} px-0 mx-0`}>
      <SubmissionListMinimalCompactDetails
        submissionList={submissionList}
      />

      <SubmissionListAdditionalServicesCompactDetails
        submissionList={submissionList}
        viewMode={viewMode}
        setShowErrorModal={setShowErrorModal}
        isMiddleman={isMiddleman}
      />
    </div>

    <div className={`d-none d-md-${viewMode !== 'grid' ? 'flex' : 'none'} justify-content-start justify-content-md-${viewMode !== 'grid' ? 'end' : 'start'} flex-wrap py-0 py-md-${viewMode !== 'grid' ? '0' : '1'} px-0 mx-0`}>
      {
        isSuperMiddleman && submissionList.middleman &&
        <div
          className="bg-aiG-gray2-imp br-50px mx-1 px-2 py-1 my-1 d-none d-lg-flex justify-content-center text-center align-items-center">
          {submissionList.middleman.business_name}
        </div>
      }
      <SubmissionListAdditionalServicesCompactDetails
        submissionList={submissionList}
        setShowErrorModal={setShowErrorModal}
        isMiddleman={isMiddleman}
      />

      <SubmissionListMinimalCompactDetails
        submissionList={submissionList}
      />
    </div>
  </React.Fragment>
}


const SubmissionListsList = ({
    submissionLists,
    setSubmissionLists,
    isMiddleman,
    isSuperMiddleman,
    viewMode,
    handleDelete,
    canBeCollected,
    addSubmissionListToRequestPickUp,
    submissionListsAnimationDivider,
    displayAll,
    setShowErrorModal
  }) => {

  const [initCompleted, setInitCompleted] = useState(false)

  useEffect(() => {
    if (!initCompleted)
      setInitCompleted(true)
  }, []);



  // Funzione che aggiorna una determinata submission list sull'interfaccia grafica
  const handleChangeSubmissionListParams = (submissionList) => {
    let newSubmissionLists = submissionLists.map((s) => {
      return s.id === submissionList.id ? { ...submissionList } : s
    });
    setSubmissionLists(newSubmissionLists)
  }


  // Funzione che gestisce il rendering sull'ìnterfaccia grafica della freccia che indica all'utente la possibilità
  // di espandere / compatare una submission list sulla vista
  const handleDisplaySubmissionListArrowDown = (submissionList, display) => {
    if (viewMode !== 'grid' && window.innerWidth >= 768) {
      removeHtmlElementClass(document, `submission_list_number_container_${submissionList.id}`, 'px-md-1');
      removeHtmlElementClass(document, `submission_list_number_container_${submissionList.id}`, 'px-md-0');
      removeHtmlElementClass(document, `submission_list_number_container_${submissionList.id}`, 'px-xxxl-2');
      removeHtmlElementClass(document, `submission_list_number_container_${submissionList.id}`, 'px-xxxl-0');

      if (display) {
        addHtmlElementClass(document, `submission_list_number_${submissionList.id}`, 'd-none');
        removeHtmlElementClass(document, `submission_list_arrow_down_${submissionList.id}`, 'd-none');
      } else {
        if (submissionList.number) {
          removeHtmlElementClass(document, `submission_list_number_${submissionList.id}`, 'd-none');
          addHtmlElementClass(document, `submission_list_arrow_down_${submissionList.id}`, 'd-none');
        }

        if (submissionList.number) {
          addHtmlElementClass(document, `submission_list_number_container_${submissionList.id}`, 'px-md-1');
          addHtmlElementClass(document, `submission_list_number_container_${submissionList.id}`, 'px-xxxl-2');
        } else {
          addHtmlElementClass(document, `submission_list_number_container_${submissionList.id}`, 'px-md-0');
          addHtmlElementClass(document, `submission_list_number_container_${submissionList.id}`, 'px-xxxl-0');
        }
      }
    }
  }

  

  return (
    <div className={`row w-100 p-0 ${isMiddleman ? 'm-0' : 'mx-0 mt-0 mb-5'}`}>
      {submissionLists.map((submissionList, i) =>
        <div key={submissionList.id} id={submissionList.id}
             className={`submission_list_container
                        col-12 col-sm-6 col-md-${viewMode !== 'grid' ? '12' : '6'} col-lg-${viewMode !== 'grid' ? '12' : '4'} col-xl-${viewMode !== 'grid' ? '12' : '3'} 
                        d-block d-md-${viewMode !== 'grid' ? 'flex' : 'block'} my-3 px-3 px-md-${viewMode !== 'grid' ? '0' : '3'}`}
            //  style={{ animation: `scale-up 0.5s ease-out ${0.100 * (i % submissionListsAnimationDivider)}s forwards` }}
        >
          <div className={`d-flex align-items-start justify-content-between justify-content-md-${viewMode !== 'grid' ? 'end' : 'between'} 
                           py-0 py-md-${viewMode !== 'grid' ? '2' : '0'} px-${viewMode !== 'grid' && displayAll ? '2' : '0'} 
                           ${displayAll ? 'minW-40px-imp minH-40px-imp' : ''}`}>
            <div className={`d-flex pb-2 py-md-${viewMode !== 'grid' ? '0' : '2'}`}>
              {
                addSubmissionListToRequestPickUp && canBeCollected(submissionList) &&
                <React.Fragment>
                  <input
                    type="checkbox"
                    className={`filter-checkbox--size select-submission-list-checkbox mr-2 mr-md-${viewMode !== 'grid' ? '0' : '2'} mr-lg-2`}
                    id={'submissionList_checkbox_' + submissionList.id}
                    checked={submissionList.checked || false}
                    onChange={(e) => addSubmissionListToRequestPickUp(submissionList) }
                  />
                </React.Fragment>
              }

              <div className={`d-flex d-md-${viewMode !== 'grid' ? 'none' : 'flex'}`}>
                <img src={window.location.origin + `/images/icons/blue/arrow-${submissionList.display_content ? 'up' : 'down'}.svg`}
                     alt="" width="18px" className="cursor-pointer"
                     onClick={ () => {
                       handleChangeSubmissionListParams({ ...submissionList, display_content: !submissionList.display_content })
                       if (!submissionList.display_content)
                         setTimeout(() => scrollHtmlElementIntoView(document, `submission_list_${submissionList.id}_content`, false), 2 * (600 / 3))
                     }} />
              </div>
            </div>

            {
              handleDelete &&
                <div className={`d-flex d-md-${viewMode !== 'grid' ? 'none' : 'flex'} pb-2`}>
                  {
                    submissionList.state === 'draft' && submissionList.can_be_edited_by_user &&
                    <div className={`d-flex justify-content-center align-items-center cursor-pointer small-delete-container pt-03px-imp pl-03px-imp`}
                         onClick={(e) => handleDelete(submissionList)}>
                      <img src="/images/close-white.svg" alt="" width="13" height="13" />
                    </div>
                  }
                </div>
            }
          </div>

          <div className="w-100 p-0">
            <div className={`row w-100 p-0 m-0 align-items-center border-aiG-light-gray-imp br-8px ${viewMode !== 'grid' ? (submissionList.display_content ? 'bg-md-aig-light-gradient' : 'on-hover-bg-md-aig-light-gradient') : ''}`}>
              <div className={`col-5 col-md-${viewMode !== 'grid' ? '2' : '5'} col-xl-${viewMode !== 'grid' ? '1-dot-5' : '5'} col-xxxl-${viewMode !== 'grid' ? '1-dot-5' : '5'} bg-aig-gradient color-white
                                            d-flex justify-content-center 
                                            px-0 px-md-${(viewMode !== 'grid' && submissionList.number) ? '1' : '0'} 
                                            px-xxxl-${(viewMode !== 'grid' && submissionList.number) ? '2' : '0'}
                                            align-items-center minH-40px-imp z-index-10
                                            cursor-pointer br-top-left-8px br-bottom-left-0px br-bottom-right-8px 
                                            br-bottom-left-md-${viewMode !== 'grid' ? '8' : '0'}px br-bottom-right-md-${viewMode !== 'grid' ? '0' : '8'}px`}
                   id={`submission_list_number_container_${submissionList.id}`}
                   onMouseOver={ () => handleDisplaySubmissionListArrowDown(submissionList, true) }
                   onMouseOut={ () => handleDisplaySubmissionListArrowDown(submissionList, false)}
                   onClick={ (e) => {
                     if (viewMode !== 'grid' && window.innerWidth >= 768) {
                       handleChangeSubmissionListParams({ ...submissionList, display_content: !submissionList.display_content })
                       e.stopPropagation()
                     }
                     else
                       window.location = `/submission_lists/${submissionList.id}`
                     if (!submissionList.display_content)
                       setTimeout(() => scrollHtmlElementIntoView(document, `submission_list_${submissionList.id}_content`, false), 2 * (600 / 3))
                   }}
              >

                <p className={`my-0 ${submissionList.number ? 'd-none' : ''}`}
                   id={`submission_list_arrow_down_${submissionList.id}`}>
                  <img src={window.location.origin + `/images/icons/white/arrow-${submissionList.display_content ? 'up' : 'down'}.svg`}
                       alt="" width="18px" />
                </p>

                <b className={`font-size-xxxl-16px ${!submissionList.number ? 'd-none' : ''}`}
                   id={`submission_list_number_${submissionList.id}`}>
                  {submissionList.number}
                </b>
              </div>

              <div className={`col-2 col-md-${viewMode !== 'grid' ? '8' : '2'} col-xl-${viewMode !== 'grid' ? '9-dot-5' : '2'} col-xxxl-${viewMode !== 'grid' ? '9-dot-5' : '2'} z-index-10 px-0`}>
                <div className={`d-none d-md-${viewMode !== 'grid' ? 'flex' : 'none'} justify-content-start justify-content-md-${viewMode !== 'grid' ? 'between' : 'start'} align-items-center px-2 cursor-pointer`}
                     onClick={() => window.location = `/submission_lists/${submissionList.id}`}>
                  <SubmissionListSummaryAllCompactDetails
                    submissionList={submissionList}
                    viewMode={viewMode}
                    isSuperMiddleman={isSuperMiddleman}
                    setShowErrorModal={setShowErrorModal}
                    isMiddleman={isMiddleman}
                  />
                </div>
                <div className={`d-flex d-md-${viewMode !== 'grid' ? 'none' : 'flex'} cursor-pointer w-100 m-0 p-0`}
                     onClick={() => window.location = `/submission_lists/${submissionList.id}`}>
                  &nbsp;
                </div>
              </div>

              <SubmissionListStateBadge submissionList={submissionList} viewMode={viewMode} />

              <div className={`col-12 d-flex d-md-${viewMode !== 'grid' ? 'none' : 'flex'} px-0`}>
                <div className={`d-block d-md-${viewMode !== 'grid' ? 'none' : 'block'} justify-content-start justify-content-md-${viewMode !== 'grid' ? 'between' : 'start'} align-items-center py-1 py-md-${viewMode !== 'grid' ? '0' : '1'}`}>
                  <SubmissionListSummaryAllCompactDetails
                    submissionList={submissionList}
                    viewMode={viewMode}
                    isSuperMiddleman={isSuperMiddleman}
                    setShowErrorModal={setShowErrorModal}
                    isMiddleman={isMiddleman}
                  />
                </div>
              </div>
            </div>

            <div className={`row slide-animation-container slide-${submissionList.display_content ? 'down' : 'up'} w-100 p-0 m-0 mt-minus-7px`} id={`submission_list_${submissionList.id}_content`}>
              <div className={`col-md-2 col-xl-1 d-flex d-md-${viewMode !== 'grid' ? 'flex' : 'none'}`}></div>

              <div className={`col-12 col-md-${viewMode !== 'grid' ? '10' : '12'} col-xl-${viewMode !== 'grid' ? '11' : '12'} border-left-aiG-light-gray-imp border-right-aiG-light-gray-imp border-bottom-aiG-light-gray-imp border-bottom-radius-8px px-0 pt-1`}>
                <div className="row w-100 pt-0 pb-1 px-0 m-0">
                  {
                    (isMiddleman || submissionList.middleman) &&
                    <React.Fragment>
                      <div className={`col-12 col-md-${viewMode !== 'grid' ? '6' : '12'} col-lg-${viewMode !== 'grid' ? '4' : '12'} col-xl-${viewMode !== 'grid' ? '2' : '12'} pt-2 pl-2 pr-0 d-flex justify-content-start`}>
                        <UserGeneralitiesSummary
                          submissionList={submissionList}
                          isMiddleman={isMiddleman}
                          labelCssClass={'submission_list_small_label'}
                          textTruncate={true}
                        />
                      </div>

                      <div className={`col-12 col-md-${viewMode !== 'grid' ? '6' : '12'} col-lg-${viewMode !== 'grid' ? '4' : '12'} col-xl-${viewMode !== 'grid' ? '2' : '12'} pt-2 pl-2 pr-0 d-flex justify-content-start`}>
                        <UserEmailSummary
                          submissionList={submissionList}
                          isMiddleman={isMiddleman}
                          isSuperMiddleman={isSuperMiddleman}
                          labelCssClass={'submission_list_small_label'}
                          textTruncate={true}
                        />
                      </div>

                      {
                        isSuperMiddleman && submissionList.middleman &&
                        <React.Fragment>
                          <div
                            className={`col-12 col-md-${viewMode !== 'grid' ? '6' : '12'} col-lg-${viewMode !== 'grid' ? '4' : '12'} col-xl-${viewMode !== 'grid' ? '2' : '12'} pt-2 pl-2 pr-0 d-flex justify-content-start`}>
                            <UserGeneralitiesSummary
                              submissionList={submissionList}
                              isMiddleman={false}
                              labelCssClass={'submission_list_small_label'}
                              textTruncate={true}
                            />
                          </div>

                          <div
                            className={`col-12 col-md-${viewMode !== 'grid' ? '6' : '12'} col-lg-${viewMode !== 'grid' ? '4' : '12'} col-xl-${viewMode !== 'grid' ? '2' : '12'} pt-2 pl-2 pr-0 d-flex justify-content-start`}>
                            <UserEmailSummary
                              submissionList={submissionList}
                              isMiddleman={false}
                              labelCssClass={'submission_list_small_label'}
                              textTruncate={true}
                            />
                          </div>
                        </React.Fragment>
                      }
                    </React.Fragment>
                  }

                  {
                    (!isMiddleman || isDefined(submissionList.voucher?.code)) &&
                    <div
                      className={`col-12 col-md-${viewMode !== 'grid' ? '6' : '12'} col-lg-${viewMode !== 'grid' ? '4' : '12'} col-xl-${viewMode !== 'grid' ? '2' : '12'} pt-2 pl-2 pr-0 d-flex justify-content-start`}>
                      <DiscountSummary
                        submissionList={submissionList}
                        labelCssClass={'submission_list_small_label'}
                        textTruncate={true}
                      />
                    </div>
                  }

                  {
                    insuranceServiceEnabled(submissionList) &&
                    <div
                      className={`col-12 col-md-${viewMode !== 'grid' ? '6' : '12'} col-lg-${viewMode !== 'grid' ? '4' : '12'} col-xl-${viewMode !== 'grid' ? '2' : '12'} pt-2 pl-2 pr-0 d-flex justify-content-start`}>
                      <InsuranceServiceSummary
                        submissionList={submissionList}
                        labelCssClass={'submission_list_small_label'}
                        textTruncate={true}
                      />
                    </div>
                  }

                  {
                    (renderHomePickupServiceDetails(submissionList) || renderReturnShipmentServiceDetails(submissionList)) &&
                    <div className={`col-12 col-md-${viewMode !== 'grid' ? '6' : '12'} col-lg-${viewMode !== 'grid' ? '4' : '12'} col-xl-${viewMode !== 'grid' ? '2' : '12'} pt-2 pl-2 pr-0 d-flex justify-content-start`}>
                      <ShippingServiceSummary
                        submissionList={submissionList}
                        labelCssClass={'submission_list_small_label'}
                        textTruncate={true}
                      />
                    </div>
                  }

                  {
                    submissionList.state !== 'draft' && submissionList.grader_company.feedbacks?.length > 0 &&
                    <div className={`col-12 col-md-${viewMode !== 'grid' ? '6' : '12'} col-lg-${viewMode !== 'grid' ? '4' : '12'} col-xl-${viewMode !== 'grid' ? '2' : '12'} pt-2 pl-2 pr-0 d-flex justify-content-start`}>
                      <div>
                        <img src={window.location.origin + `/images/icons/gray/rate.svg`} alt="rate" />
                      </div>
                      <div className="d-block pl-2">
                        <p className="mt-1">
                          <small className="submission_list_small_label mr-2">
                            {I18n.t(`js.indexSubmissionListsPage.${isMiddleman && !submissionList.can_be_evaluated_by_current_user ? 'customerEvaluation' : 'evaluation'}`).toUpperCase()}
                          </small>
                        </p>
                        <OverallEvaluation
                          id={submissionList.id}
                          overall={!submissionList.evaluations || Object.keys(submissionList.evaluations).length === 0 ? 0 : Object.values(submissionList.evaluations).reduce((acc, curr) => acc + curr, 0) / Object.keys(submissionList.evaluations).length}
                        />
                      </div>
                    </div>
                  }

                  {
                    isMiddleman &&
                    <div className={`col-12 col-xl-${viewMode !== 'grid' ? '6' : '12'} pt-2 pl-2 pr-0 d-flex justify-content-start`}>
                      <div>
                        <img src={window.location.origin + `/images/icons/gray/money.svg`} alt="amount" />
                      </div>
                      <div className="d-block pl-2">
                        <p className="mt-1">
                          <small className="submission_list_small_label mr-2">
                            {I18n.t("js.editSubmissionListPage.amount").toUpperCase()}
                          </small>
                        </p>
                        <div>
                          <ItemPricing
                            item={submissionList}
                            amountToRender={isMiddleman ? 'amount' : 'customer_amount'}
                          />
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>

          {
            handleDelete &&
              <div className={`d-flex align-items-start justify-content-start minW-40px-imp minH-40px-imp py-0 py-md-${viewMode !== 'grid' ? '2' : '0'} px-${viewMode !== 'grid' ? '2' : '0'}`}>
                {
                  submissionList.state === 'draft' && submissionList.can_be_edited_by_user &&
                  <div className={`cursor-pointer d-none d-md-${viewMode !== 'grid' ? 'flex' : 'none'} justify-content-center align-items-center ml-md-0 ml-lg-1 small-delete-container pt-03px-imp pl-03px-imp`}
                       onClick={(e) => handleDelete(submissionList)}>
                    <img src="/images/close-white.svg" alt="" width="13" height="13" />
                  </div>
                }
              </div>
          }
        </div>
      )}
    </div>
  );
};

export default SubmissionListsList;